var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17.5,
    height: 17.5,
    x: 1.25,
    y: 1.25,
    fill: "#1275B1",
    rx: 8.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.887 6.058c0 .584-.507 1.057-1.131 1.057-.625 0-1.131-.473-1.131-1.057 0-.585.506-1.058 1.13-1.058.625 0 1.132.473 1.132 1.058ZM5.78 7.893h1.933v5.857H5.78V7.893Zm5.045 0H8.892v5.857h1.933v-2.997c0-.692.236-1.387 1.179-1.387 1.065 0 1.059.906 1.054 1.607-.006.917.009 1.853.009 2.777H15v-3.091c-.016-1.974-.53-2.884-2.223-2.884-1.005 0-1.628.456-1.952.87v-.752Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.1b36ebd9b042ad60c71092d6b02c8d0a.svg";
export { ForwardRef as ReactComponent };